export const itemsListData = [
    { label: "Serviços", to: "/#services" },
    { label: "Quem Somos", to: "/#pillars" },
    { label: "Casos de Sucesso", to: "/#successCases" },
    { label: "Clientes", to: "/#clients" },
    { label: "Blog", to: "/blog" },
    { label: "Trabalhe conosco", to: "/carreiras" }
];